import { render, staticRenderFns } from "./ModalCustomerPurchaseOrderDetails.vue?vue&type=template&id=5255e8f9&lang=pug&"
import script from "./ModalCustomerPurchaseOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerPurchaseOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports